import { SVGProps } from 'react';

const LogoShort = ({
  props,
}: {
  props?: SVGProps<SVGSVGElement>;
  mainColor?: string;
  secondaryColor?: string;
  height?: string | number;
  width?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20" fill="none" {...props}>
    <g fill="#fff" opacity=".5">
      <path d="m5.2 19.038 1.926-7.695L4.333 0H0l5.2 19.038ZM14.3 0l-1.98 7.903 2.846 11.135 1.926-7.695L14.3 0Z" />
    </g>
    <path
      fill="#fff"
      d="M9.538 19.038H5.205L9.972 0h4.333L9.538 19.038ZM19.504 19.038h-4.333L19.938 0h4.333l-4.767 19.038Z"
    />
  </svg>
);

export default LogoShort;
